import api from "services/finances";

const state = {
  candidates: {
    users: [],
    pagination: [],
    totalPages: "",
    currentPage: ""
  },
  payments: {
    payments: [],
    pagination: [],
    totalCashed: null
  },
  selected: {},
  searchQuery: {
    search: "",
    reference: "",
    fileStatus: null,
    financeStatus: null,
    accountingReviewStatus: null,
    status: null,
    campuses: null,
    schools: null,
    year: null,
    location: null,
    located: null,
    registrationStubMonth: null,
    registrationStubYear: null,
    collectBegin: null,
    collectEnd: null
  },
  selectedFilters: {
    fileStatus: null,
    financeStatus: null,
    accountingReviewStatus: null,
    status: null,
    campuses: null,
    schools: null,
    year: null,
    location: null,
    located: null,
    registrationStubMonth: null,
    registrationStubYear: null,
    collectBegin: null,
    collectEnd: null
  },
  status: null
};

const getters = {
  getAllUsers: state => state.candidates.users,
  getAllUserCount: state => state.candidates.users.length,
  getSelectedUser: state => state.selected,
  getSearchQuery: state => state.searchQuery,
  getSelectedFilters: state => state.selectedFilters,
  getStatus: state => state.status,
  totalPages(state) {
    return state.candidates.pagination.total_pages;
  },
  currentPage(state) {
    return state.candidates.pagination.current_page;
  },
  pagination(state) {
    return state.candidates.pagination;
  },
  payments(state) {
    return state.payments;
  },
};

const mutations = {
  setUsers: (state, payload) => {
    state.candidates.users = payload.users;
    state.candidates.pagination = payload.meta.pagination;
    const { total, limit, skip } = state.candidates.pagination;
    state.candidates.totalPages = Math.ceil(total / limit);
    state.candidates.currentPage = Math.ceil((skip - 1) / limit) + 1;
  },
  selectUser: (state, payload) => {
    state.selected = payload;
  },
  resetSearch: state => {
    state.selectedFilters = {
      search: null,
      reference: null,
      fileStatus: null,
      financeStatus: null,
      status: null,
      schools: null,
      year: null,
      campuses: null,
      location: null,
      located: null,
      registrationStubMonth: null,
      registrationStubYear: null,
      collectBegin: null,
      collectEnd: null
    };

    state.searchQuery = {
      search: "",
      reference: "",
      fileStatus: null,
      financeStatus: null,
      status: null,
      schools: null,
      year: null,
      campuses: null,
      location: null,
      located: null,
      registrationStubMonth: null,
      registrationStubYear: null,
      collectBegin: null,
      collectEnd: null
    };
  },
  setStatus: (state, payload) => {
    state.status = payload.status;
  },
  setPayments: (state, payload) => {
    state.payments.payments = payload.payments;
    state.payments.totalAmount = payload.meta.totalAmount;
    state.payments.totalCashed = payload.meta.totalCashed;
    state.payments.pagination = payload.meta.pagination;
  },
  updatePayments: (state, payload) => {
    for (var i = 0, len = payload.length; i < len; i++) {
      const index = _.findIndex(state.payments.payments, { id: payload[i].id });
      state.payments.payments.splice(index, 1, payload[i]);
    }
  },
  updateLocation: (state, payload) => {
    const index = _.findIndex(state.payments.payments, { id: payload.id });
    state.payments.payments.splice(index, 1, payload);
  }
};

const actions = {
  async setUsers({ commit }, query) {
    const payload = await api.finances(query);
    if ((await payload.status) === 200) {
      commit("setUsers", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async setUserBalances({ commit }, query) {
    const payload = await api.balances(query);
    if ((await payload.status) === 200) {
      commit("setUsers", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async selectUser({ commit }, id) {
    const payload = (await api.showUser(id)).data;
    commit("selectUser", await payload);
  },
  resetSearch({ commit }) {
    commit("resetSearch");
  },
  async setPayments({ commit }, query) {
    const payload = await api.financesType(query);
    if ((await payload.status) === 200) {
      commit("setPayments", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async setCheckPayments({ commit }, query) {
    const payload = await api.financesCheckStatus(query);
    if ((await payload.status) === 200) {
      commit("setPayments", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async setCashFlowPayments({ commit }, query) {
    const payload = await api.financesCashFlow(query);
    if ((await payload.status) === 200) {
      commit("setPayments", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async setTotalCashFlowPayments({ commit }, query) {
    const payload = await api.financesTotalCashFlow(query);
    if ((await payload.status) === 200) {
      commit("setPayments", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async updatePayments({ commit }, data) {
    const payload = await api.updatePayment(data);
    if ((await payload.status) === 200) {
      commit("updatePayments", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async switchPaymentLocation({ commit }, data) {
    const payload = await api.switchPaymentLocation(data);
    if ((await payload.status) === 200) {
      commit("updateLocation", await payload.data);
    }
    commit("setStatus", await payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
